module.exports = __webpack_public_path__ + "img/rectangle-46.47353e8d.svg";